/* eslint-disable max-len */
import React from 'react'
import { motion } from "framer-motion";

const AnimatedList = ({ child, keyItem, rowStatus,handleClick, cursorpointer,title }) => {
    return (
        <motion.tr
            key={keyItem}
            onClick={(e)=>{
                if(handleClick){
                    handleClick(e)
                }
            }}
            title={title}
            // initial={{ opacity: 0, y: 20 }}
            // animate={{ opacity: 1, y: 0 }}
            // transition={{ duration: 0.3, delay: keyItem * 0.1 }}
            /*animate={{ opacity: 1, x: 0 }}
            initial={{ opacity: 0, x: -10 }}
            exit={{ opacity: 0, x: -10 }}   
            transition={{ duration: 0.15 }}*/
            className={`${(rowStatus !== undefined && rowStatus )? '' : 'inactive'} ${cursorpointer ? 'cursor-pointer' : ''} `}
        >
            {child}
        </motion.tr>
    );
}

export default AnimatedList;